// extracted by mini-css-extract-plugin
module.exports = {"divWithBackground":"style_divWithBackground__15Tal"};